import { DNode } from '@dojo/widget-core/interfaces';
import { v } from '@dojo/widget-core/d';

import * as css from './styles/VideoList.m.css';
import * as aLcss from './styles/ActionList.m.css';
import * as parentcss from './styles/Ticker.m.css';

import util from '../util';

export interface VideoContextProperties {
    action: string,
    seconds: number,
    team_id: number,
}

export interface VideoElementProperties {
    description: string | null,
    duration: number,
    id: number,
    match_id: number,
    title: string | null,
    url_thumbnail: string | null,
    context: VideoContextProperties,
}

export interface VideoListProperties {
    videoElements: VideoElementProperties[];
    loaded: boolean;
}


export class VideoList {    
    public static generateVideoLine(line: VideoElementProperties, lineNumber: number) : DNode {
        return (
            v('div', {classes: [aLcss.tabbodyrow], key: 'video#' + lineNumber}, [
                v('div',        { classes: [ parentcss.tabbodycell, parentcss.actiontext, parentcss.right, parentcss.hideifsmall ] },  [ "" ]),
                v('div',        { classes: [ parentcss.tabbodycell, parentcss.actiontext, parentcss.left, parentcss.hideifwide ] },    [ "" ]),
                v('div',        { classes: [ parentcss.tabbodycell, parentcss.actioniconleft ]}, [
                    line.url_thumbnail == null ? "" : v('a', {href: "https://www.yousport.tv/video/" + line.id, target: "_blank" }, [
                        v('img', {classes: [ css.icon ], src: line.url_thumbnail } ),
                    ])
                ]),
                v('div',        { classes: [ parentcss.tabbodycell, parentcss.restime  ] },   [
                    v('div',    {classes:  [ parentcss.time]}, [  util.formatTime(line.context.seconds) ]),
                    v('div',    {classes: [parentcss.result]}, [ line.duration + "s" ]),
                ]),
                v('div',        { classes: [ parentcss.tabbodycell, parentcss.actioniconright ] },   [ "" ]),
                v('div',        { classes: [ parentcss.tabbodycell, parentcss.actiontext, parentcss.left, parentcss.hideifsmall ] },
                   [ "Video" ]),
            ])
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/@dojo/webpack-contrib/css-module-dts-loader?type=ts&instanceName=0_dojo!./src/widgets/VideoList.ts